export const tables = {
  auth: "auth",
  responder: "responder",
  incident: "incident",
  evidences: "evidences",
  comments: "comments",
  canaries: "canary",
  catalog: "config",
  topologies: "component",
  config_scrapers: "scraper",
  people: "person",
  connections: "connection",
  kratos: "kratos",
  agents: "agent",
  properties: "properties",
  logging_backends: "logging_backends",
  integrations: "integrations",
  plugins: "plugins",
  notifications: "notification",
  notification_silences: "notificationSilence",
  playbooks: "playbook",
  playbook_runs: "playbook_runs",
  roles: "role",
  role_bindings: "roleBinding",
  scopes: "scope",
  views: "view",
  teams: "team",
  applications: "application",
  artifacts: "artifacts",
  tokens: "tokens",
  jobs: "job:read",
  events: "event:read",
  mcp: "mcp:use",
  access_review: "access:review"
};
